<template>
  <div>
    <el-tooltip
      class="item"
      effect="dark"
      placement="top"
    >
      <div
        slot="content"
        class="detail-tip-view"
      >
        <div>{{$lang('类型')}}: {{netAbmWaybill.levelOneTypeName}} {{netAbmWaybill.levelTwoTypeName}}</div>
        <div>{{$lang('问题描述')}}: {{netAbmWaybill.abnormalCauses}}</div>
        <template>
          <div>{{$lang('应对话术')}}: {{netAbmWaybill.speechcraft}}</div>
          <div>{{$lang('解决方案')}}: {{netAbmWaybill.solution}}</div>
          <div style="text-align: center">
            <el-button
              type="primary"
              @click="copyText(netAbmWaybill.solution)"
            >{{$lang('复制')}}</el-button>
          </div>
        </template>
      </div>
      <span v-show="waybillNo && !isEmptyObj(netAbmWaybill)">
        <i
          style="color:red;"
          class="el-icon-warning customer-type"
        ></i>
      </span>
    </el-tooltip>
  </div>
</template>

<script>
import { RecordSheet } from './pool'
import { isEmptyObj, copyText } from '@/common/utils/tool'

export default {
  data() {
    return {
      isEmptyObj,
      copyText,
      netAbmWaybill: {} // 网点异常管理--异常运单详情
    };
  },
  props: {
    waybillNo: {
      type: String,
      default: () => ''
    }
  },
  mounted() {

  },

  methods: {
    // 网点异常管理--异常运单详情
    async getNetWaybill(waybillNo) {
      RecordSheet.getNetWaybill(waybillNo).then(({ data }) => {
        this.netAbmWaybill = { ...data }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.leftform-customer-type {
  position: relative;
  .customer-type {
    position: absolute;
    left: -14px;
    top:3px;
    font-weight: bolder;
    font-size: 16px;
    white-space: nowrap;
  }
}
</style>
